import React from "react";
import {
  Row,
  Col,
  Button,
  Space,
  Dropdown,
  message,
  Image,
  Modal,
  Tooltip,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext, StoreProvider } from "../store/RootStore";
import { Link } from "react-router-dom";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import SchoolCalenderStore from "../store/SchoolCalenderStore";
import CompanyStore from "../store/CompanyStore";
import SchoolCalenderAdd from "./SchoolCalenderAdd";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import kebabIcon from "../assets/images/NewDesign/kebab.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import { CloseOutlined } from "@ant-design/icons";
import withRouter from "../withRouter";
class SchoolCalenderList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.onDelete = this.onDelete.bind(this);
    this.companyStore = new CompanyStore(this);

    this.schoolCalenderStor = new SchoolCalenderStore();

    // console.log(this.context);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      openConfirm: false,
      confirmLoading: false,
      companyId: "",
      loadList: 0,
      company_value_label: "",
      calenderId: "",
      openCalenderForm: false,
      listDataUpdate: false,
      openDeleteModal: false,
      deleteData: {},
    };

    this.columns = [
      {
        // title: "Academic Year From",
        title: context.translate("_ACADEMIC_YEAR_FROM_"),
        width: 150,
        dataIndex: "yearFrom",
        fixed: "left",
        ellipsis: {
          showTitle: true,
        },
        render: (value, record) => {
          return (
            <Tooltip placement="topLeft" title={value}>
              <Link
                style={{ color: "#2563EB", textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.props.canUpdate("schoolcalenderlist") &&
                    this.onEdit(record);
                }}
              >
                {value}
              </Link>
            </Tooltip>
          );
        },
      },
      {
        // title: "Academic Year To",
        title: context.translate("_ACADEMIC_YEAR_TO_"),
        width: 150,
        dataIndex: "yearTo",
        ellipsis: {
          showTitle: true,
        },
        fixed: "left",
      },

      {
        title: context.translate("_ACTION_"),
        dataIndex: "Action",
        key: "Action",
        fixed: "right",
        width: 50,
        ellipsis: {
          showTitle: true,
        },
        align: "center",
        render: (_, record) => {
          return (
            <>
              <Space>
                {this.props.canUpdate("schoolcalenderlist") && (
                  <Tooltip
                    title={this.context.translate("_EDIT_RECORD_")}
                    placement="bottom"
                  >
                    <Image
                      style={{
                        height: "19px",
                        width: "15px",
                        borderRadius: "0px",
                        cursor: "pointer",
                      }}
                      src={editIcon}
                      onClick={async (e) => {
                        e.preventDefault();
                        await this.onEdit(record);
                      }}
                    ></Image>
                  </Tooltip>
                )}
                {this.props.canDelete("schoolcalenderlist") && (
                  <Tooltip
                    title={this.context.translate("_DELETE_RECORD_")}
                    placement="bottom"
                  >
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer", width: "15px" }}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    ></Image>
                  </Tooltip>
                )}
              </Space>
            </>
          );
        },
      },
    ];

    this.ExportMenuProps = {
      items: [
        {
          label: context.translate("_DASHBOARD_"),
          key: "dashboard",
          icon: (
            <i
              class="bi bi-speedometer2"
              style={{ marginInlineEnd: "5px" }}
            ></i>
          ),
        },
      ],
    };
  }
  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      console.log(this.props.getUserData().userCompanyId);
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }

    this.setState({ pageSize: 50 });
  }
  async componentDidUpdate(prevProps, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const beforeEditCompanyId =
        this.context.viewStateStore.schoolCalendarObject.companyId;
      if (beforeEditCompanyId) {
        await this.schoolCalenderStor.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: beforeEditCompanyId,
        });
        const singleData = await this.companyStore.getCompanyDataById(
          this.context.viewStateStore.schoolCalendarObject.companyId
        );
        await this.setState({ listUpdated: 1 }); //need to reload data
        await this.setState({ company_value_label: singleData });
        await this.setState({ listDataUpdate: false });
      }
    }
  }

  onEdit = async (record) => {
    // console.log(record.passengerId)
    const calenderId = record.calenderId;
    await this.context.viewStateStore.setSchoolCalendarStates({
      companyId: record.companyId,
    });
    if (calenderId) {
      // this.props.navigate("/schoolcalenderadd/" + calenderId
      await this.setState({ calenderId: calenderId });
      await this.setState({ openCalenderForm: true });
    }
  };
  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({ companyId: comp.value });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    await this.setState({ company_value_label: singleData });
    await this.handleSearch();
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.schoolCalenderStor.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      companyId: this.state.companyId,
    });
    await this.setState({ loadList: 1 });
  }
  async onDelete(record) {
    const response = await this.schoolCalenderStor.deleteRecord({
      calenderId: record.calenderId,
    });
    // console.log(response.data.success)
    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  responseMsg = async (resp) => {
    console.log(resp);
    if (resp.success == "S") {
      message.success(resp.message);
      // message.success("Calender Details Saved");
      await this.setState({ openCalenderForm: false });
      await this.setState({ listDataUpdate: true });

      //  await this.handleSearch();
      // this.props.navigate("/schoolcalenderlist");
    } else {
      message.error(resp.message);
    }
  };
  closeModal = () => {
    this.setState({ openCalenderForm: false, calenderId: "" });
  };
  refreshList = async () => {
    if (this.state.companyId) {
      this.setState({ loading: true });
      await this.schoolCalenderStor.loadData({
        offset: 0,
        limit: 50,
        companyId: this.state.companyId,
      });
      this.setState({ loading: false, currentPage: 1 });
    }
  };

  render() {
    return (
      <>
        <div className="listHeader">
          {/* <div className='heading'>Grade Bus Timings</div> */}
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  // allowClear={true}
                  className="searchInput"
                  value={
                    this.state.company_value_label
                      ? this.state.company_value_label
                      : null
                  }
                  onChange={this.handleChange}
                  style={{ width: 200 }}
                />
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={8}
            >
              <Tooltip
                title={this.context.translate("_REFRESH_")}
                placement="bottom"
              >
                <Image
                  style={{
                    height: 18,
                    marginInlineEnd: "30px",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  src={refreshIcon}
                  onClick={() => this.refreshList()}
                ></Image>
              </Tooltip>
              <Dropdown
                overlayClassName="export-dropdown"
                menu={this.ExportMenuProps}
              >
                <Image
                  style={{
                    height: 18,
                    alignItems: "center",
                    marginInlineEnd: "30px",
                  }}
                  src={kebabIcon}
                ></Image>
              </Dropdown>

              {this.props.canCreate("schoolcalenderlist") && (
                <Button
                  className="addButtonClass"
                  onClick={() =>
                    this.setState({ openCalenderForm: true, calenderId: "" })
                  }
                >
                  <Image
                    style={{ marginInlineEnd: "5px", width: 13 }}
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  ></Image>
                  {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                </Button>
              )}
            </Col>
          </Row>

          <ListTable
            pageSize={this.state.pageSize}
            current={this.state.currentPage}
            total={this.schoolCalenderStor?.total}
            columns={this.columns}
            dataSource={this.schoolCalenderStor?.schoolCalender}
            loading={this.schoolCalenderStor?.loading}
            onChange={this.handleTableChange}
          />

          {this.state.openCalenderForm && (
            // <Modal
            //   bodyStyle={{ height: "637px" }}
            //   className="formShowModal" //  {/* css class */}
            //   // title="School Calendar Details"
            //   title={this.context.translate("_SCHOOL_CALENDER_DETAILS_")}
            //   centered
            //   visible={this.state.openCalenderForm}
            //   footer={null}
            //   onCancel={() => {
            //     this.setState({ openCalenderForm: false, calenderId: "" });
            //   }}
            //   width={665}
            // >
            <Drawer
              className="uploadExcelDrawer"
              width={716}
              closeIcon={false}
              open={this.state.openCalenderForm}
              placement={this.context.locale.language === "english" ? "right" : "left"}
              footer={false}
              title={
                <div className="formTitle">
                  {this.context.translate("_CALENDER_DETAILS_")}
                  <p className="formDescription">
                    {this.context.translate("_CALENDER_DETAILS_DESC_")}
                  </p>
                </div>
              }
              maskClosable={false}
              onOk={() => this.setState({ openCalenderForm: false })}
              onCancel={() =>
                this.setState({ openCalenderForm: false, calenderId: "" })
              }
            >
              <div style={{ height: "100%" }}>
                <SchoolCalenderAdd
                  calenderId={this.state.calenderId}
                  response={this.responseMsg}
                  closeModal={this.closeModal}
                />
              </div>
            </Drawer>
          )}
        </div>
        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
SchoolCalenderList.contextType = StoreContext;
export default observer(withRouter(SchoolCalenderList));
